import { motion } from "framer-motion";
import { Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 md:h-[110px] py-8 md:py-0 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <img
            src="/images/c2h-logo.webp"
            alt="C2H Energy"
            data-testid="footer-logo"
            className="h-10 w-10 object-contain"
            loading="lazy"
          />
          <p data-testid="footer-copyright" className="text-sm text-[#c3ccd8]">
            © C2H Energy · ABN 62 675 591 107 · Victoria, AU
          </p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs uppercase tracking-[0.2em] text-white/40">
            Follow us
          </span>
          <a
            href="https://instagram.com/c2henergy/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 bg-cream text-navy rounded-full px-4 py-2 text-sm font-semibold hover:bg-white transition-colors duration-200"
          >
            <Instagram className="w-4 h-4 text-gdark" />
            @c2henergy
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61593841037346"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="inline-flex items-center gap-2 bg-cream text-navy rounded-full px-4 py-2 text-sm font-semibold hover:bg-white transition-colors duration-200"
          >
            <Facebook className="w-4 h-4 text-gdark" />
            C2H Energy
          </a>
        </div>
        <p
          data-testid="footer-brighte-disclaimer"
          className="mt-8 text-xs text-white/50 leading-relaxed max-w-3xl"
        >
          Brighte 0% Interest Payment Plan: available on heat pump hot water
          systems. Fees, terms and conditions apply, including an establishment
          fee and a weekly account keeping fee. All applications are subject to
          Brighte&apos;s credit approval. Finance is provided by Brighte
          Capital Pty Ltd, Australian Credit Licence 508217.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
